import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./FooterMobile.module.css";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";

import homeicon from "../../assets/icons/homeicon.png";
import invoiceicon from "../../assets/icons/invoiceicon.png";
import loginicon from "../../assets/icons/loginicon.png";
import logouticon from "../../assets/icons/logouticon.png";
import carticon from "../../assets/icons/carticon.png";
import { useAuth } from "../../context/auth";

const FooterMobile = () => {
  const MAIN_URL = process.env.REACT_APP_URL;

    const location = useLocation();
    const { LogoutUser } = useAuth();
  const token = localStorage.getItem("token");

 // count the cart prodcts
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const fetchCartItems = async () => {
      try {
        const token = localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(
          `${MAIN_URL}/api/cart/getCartItems`,
          config
        );
        setCartItems(response.data.products);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };

    fetchCartItems();
  }, []);

  const totalQuantity = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );




  return (
    <>
       {/* <div className={styles.footer_container}> */}
          <footer className={styles.footer}>
            <div className={styles.footer_container}>
              <NavLink to="/home" className={styles.footer_link}>
                <img
                  src={homeicon}
                  alt="Home icon"
                  className={styles.footer_icon}
                />
                Home
              </NavLink>
              <div className={styles.count_number}>
              <NavLink to="/viewcart" className={styles.footer_link}>
                <img
                  src={carticon}
                  alt="Cart icon"
                  className={styles.footer_icon}
                />
                Cart
              <p className={styles.cart_count}>{totalQuantity}</p>

              </NavLink>
              </div>
              {!(location.pathname === '/viewcart' || location.pathname === '/singleproduct/:id' || location.pathname === '/checkout') && (
              <NavLink to="/invoices" className={styles.footer_link}>
                <img
                  src={invoiceicon}
                  alt="Invoice icon"
                  className={styles.footer_icon}
                />
                Invoice
              </NavLink>
              )}

              {token ?  (
                <NavLink
                  to="/home"
                  className={styles.footer_link}
                  onClick={LogoutUser}
                >
                  <img
                    src={logouticon}
                    alt="Logout icon"
                    className={styles.footer_icon}
                  />
                  Logout
                </NavLink>
              ) : (
                <NavLink to="/login" className={styles.footer_link}>
                  <img
                    src={loginicon}
                    alt="Login icon"
                    className={styles.footer_icon}
                  />
                  Login
                </NavLink>
              )}
            </div>
          </footer>
        {/* </div> */}
    </>
  )
}

export default FooterMobile
